<template>

  <div  >
    <!-- supplier Modal -->
    <b-modal
        v-model="showModalInternal"
        id="package-order-details-form-modal-form"
        scrollable
        :title="title"
        title-class="font-18"
        size="xl"
        hide-footer
    >

      <div class="row">
        <PackageOrderForm ref="packageOrderFormRef" :initialPackageOrderData="initialPackageOrderData" applyBtnTitle="Zapisz" @onApplyData="onSave"/>
      </div>



    </b-modal>
  </div>



</template>
<script>
import {defineComponent} from 'vue'
import {BModal} from "bootstrap-vue-next";
import PackageOrderForm from "@/views/PackagesManager/PackageOrderForm.vue";
export default defineComponent({
  name: "PackageOrderFormModal",
  props: {
    showModal:{
      type: Boolean,
     required: true
    },
    title:{
      type:String,
      default: ()=>"Szczegóły zamówienia pakietowego"
    },
    initialPackageOrderData: {
      type: Object,
      required: false
    }

  },
  emits: ["update:showModal","onSave","onClose"],
  components: {PackageOrderForm, BModal},
  data(){
    return {
      showModalInternal:this.showModal,
      selectedSuppliers:null,

    }
  },
  methods:{
    onSave(event){
      this.$emit("onSave",event)
      this.closeModal()
    },
    closeModal(){
      this.showModalInternal = false
      this.$emit("onClose")
    }
  },
  watch:{
    // Watch parent prop changes and sync
    showModal(newValue) {
      this.showModalInternal = newValue;
    },
    // Watch local copy and emit to parent
    showModalInternal(newValue) {
      this.$emit('update:showModal', newValue);
    }
  },
  created(){
    console.log("initialPackageOrderData in modal:",this.initialPackageOrderData)
  }
})
</script>
<style scoped>
.modal-footer-container {
  position: sticky;
  bottom: -19px;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 60;
  padding: 0;
}

.modal-footer-bottom {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 18px 24px;
}


</style>
